import React from 'react'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { useMutation } from 'react-apollo'
import { ButtonIcon, LocalizedText, useHandler, download, PermissionTooltip } from 'labguard-cdk'
import { PrintIcon } from 'src/components/common/icons'
import { useAppPermission } from 'src/hooks'

const mutation = gql`
  mutation printGroups($groupIds: [ID!]!, $utcOffset: Int!) {
    printGroups(groupIds: $groupIds, utcOffset: $utcOffset)
  }
`

export default function GroupsPrintButton({ getIds }) {
  const [mutate] = useMutation(mutation)
  const enablePrint = useAppPermission('groups.print')
  const onClick = useHandler(() =>
    mutate({
      variables: { groupIds: getIds(), utcOffset: new Date().getTimezoneOffset() },
    }).then(({ data }) => download(data.printGroups, 'print.pdf'))
  )

  return (
    <PermissionTooltip allowed={enablePrint} placement="bottom">
      <ButtonIcon color="secondary-light" disabled={!enablePrint} onClick={onClick} icon={PrintIcon}>
        <LocalizedText id="WEB_PRINT" />
      </ButtonIcon>
    </PermissionTooltip>
  )
}

GroupsPrintButton.propTypes = {
  getIds: PropTypes.func,
}
